import React, {Component} from 'react';
import {
    Grid,
    Row,
    Col
} from 'react-bootstrap';
import {GetReportData} from 'api/ReportsApi';
import ReactTable from "react-table";
import moment from "moment";
import Loader from "components/Loader.jsx";

class Reports extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'data': [],
            'filter':{},
            'page': 1,
            'pages': 0,
            'defaultPageSize': 100,
            'loading': true,
            'loader':false,
            'errorMessage': null,
            'success': null
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = (page=this.state.page) => {
        this.setState({errorMessage: null, loading: true, loader: true})
        let requestData = {'page':page, 'rows':this.state.defaultPageSize}
        GetReportData(requestData).then((res) => {
            res = res.data.data;
            this.setState({data: res.reports, loading: false, loader:false});
        }).catch(err => {
            this.setState({errorMessage: err, loading: false, loader: false})
        });
    }

    render() {
        return (
            <div className="main-content container">
                <Loader loading={this.state.loader}/>
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <h3>Medical Reports</h3>
                                    <div> 
                        
                                        <ReactTable
                                            columns={[
                                                {   
                                                    Header: "Report", 
                                                    accessor: "media_detail.download_url", 
                                                    Cell: row => ( <a href={row.value} target='_blank' className="view-btn"> View Report </a> ) 
                                                },
                                                {
                                                Header: "Patient Name",
                                                accessor: "media_detail.patient_name"
                                                },
                                                {
                                                    Header: "Pathology Name",
                                                    accessor: "path_detail.client_name"
                                                }, 
                                                {   
                                                    Header: "Date", 
                                                    accessor: "media_detail.created_at", 
                                                    Cell: row => (
                                                        <span>{moment(row.value).format('MMM DD, YYYY')}</span> )
                                                }
                                            ]}
                                            noDataText="No Report Available"
                                            filterable={true}
                                            defaultPageSize={this.state.defaultPageSize}
                                            minRows={1}
                                            // showPageSizeOptions={false}
                                            showPagination={false}
                                            data={this.state.data} 
                                            // loading={this.state.loading}
                                            className="custom-react-table"
                                        />
                                    </div>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default Reports;


// WEBPACK FOOTER //
// ./src/views/reports.jsx